import React from "react";

// Define the types for props
interface DateTimeDisplayProps {
  value: number;
  type: string;
  isDanger: boolean;
}

// DateTimeDisplay component with typed props
const DateTimeDisplay: React.FC<DateTimeDisplayProps> = ({
  value,
  type,
  isDanger,
}) => {
  return (
    <div className={isDanger ? "countdown danger" : "countdown"}>
      <p>{value}</p>
      <span>{type}</span>
    </div>
  );
};

export default DateTimeDisplay;
